import { Select } from "antd";
import React from "react";

interface EmploymentSelectProps {
  value?: any;
  onChange?: (option: { label: string; value: string } | null) => void;
  className?: string;
}

const employmentOptions = [
  { label: "Full-Time", value: "full-time" },
  { label: "Part-Time", value: "part-time" },
];

const EmploymentSelect: React.FC<EmploymentSelectProps> = ({ value, onChange, className }) => {
  return (
    <Select
      options={employmentOptions}
      value={value}
      onChange={onChange}
      placeholder="Select Employment Type"
      className={className}
      style={{height: "40px"}}
      // isClearable
    />
  );
};

export default EmploymentSelect;
